import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ViaCheckApiQueryService} from './via-check-api-query.service';
import {emailType} from '../models/emailbody.interface';

@Injectable({
  providedIn: 'root',
})
export class MailerService extends ViaCheckApiQueryService {
  /**
   * @param emailInfo es tipo MailOptions de nodemailer.
   * @descrition Envia Correos de parte de monitor austral.
   * @returns Un string con mensaje de exito o fracaso total.
   */
  public sendEmail(emailBody: emailType): Observable<string> {
    const subdomain = 'mailer';
    return this.networkRequest('post', subdomain, emailBody);
  }
}
